import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';

import { BaseButton } from '@shared/components/base';
import { isStaleBuildError, reloadOnce } from '@shared/lib/staleBuild';

import { APP_TEXT } from '../constants';

/** Error boundary for every route: a crash in one screen never blanks the whole app. A screen
 *  that couldn't load because a deploy replaced its files reloads into the new version. */
export function RouteErrorPage() {
  const error = useRouteError();
  const staleBuild = isStaleBuildError(error);
  useEffect(() => {
    if (staleBuild) reloadOnce();
  }, [staleBuild]);

  if (staleBuild)
    return (
      <section role="alert" className="m-6 rounded-app border border-line bg-surface p-4">
        <h1 className="text-base font-bold">{APP_TEXT.routeError.updatedTitle}</h1>
        <p className="mt-1 mb-3 text-[13px] text-text-2">{APP_TEXT.routeError.updatedMessage}</p>
        <BaseButton
          onClick={() => {
            window.location.reload();
          }}
        >
          {APP_TEXT.routeError.reload}
        </BaseButton>
      </section>
    );

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : APP_TEXT.routeError.unexpected;
  return (
    <section role="alert" className="m-6 rounded-app border border-crit-line bg-crit-soft p-4 text-crit">
      <h1 className="text-base font-bold">{APP_TEXT.routeError.title}</h1>
      <p className="nocaps mt-1 text-[13px]">{message}</p>
    </section>
  );
}
